import { defineComponent as _defineComponent } from 'vue'
import UiDropdown from '../UiDropdown.vue';
import vClickOutside from '../../directives/click-outside';
import { computed, ref } from 'vue';
import { useBreakpoints } from 'JS/composables/breakpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'PriceToolTip',
  props: {
    isTire: { type: Boolean },
    preventOverflow: { type: Boolean }
  },
  setup(__props: any) {



const { isMobile } = useBreakpoints();
const customWidth = computed(() => isMobile.value ? 220 : 300);
const showInfoMessage = ref(false);

function toggleInfoMessage() {
	showInfoMessage.value = !showInfoMessage.value;
}

function closeInfoMessage() {
	showInfoMessage.value = false;
}

return { __sfc: true,isMobile, customWidth, showInfoMessage, toggleInfoMessage, closeInfoMessage, UiDropdown, vClickOutside }
}

})